module.exports = __webpack_public_path__ + "static/media/md-umbrella.c153669b.svg";